import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  Box, Button, TextField, Typography, Paper, CircularProgress,
  FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

function PontoRelatorio() {
  const { user } = useAuth();
  const [funcionarios, setFuncionarios] = useState([]);
  const [pessoaId, setPessoaId] = useState('');
  const [dataInicio, setDataInicio] = useState(() => {
    const d = new Date();
    d.setDate(1);
    return d.toISOString().split('T')[0];
  });
  const [dataFim, setDataFim] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() + 1, 0);
    return d.toISOString().split('T')[0];
  });
  const [loadingPdf, setLoadingPdf] = useState(false);

  const fetchFuncionarios = useCallback(() => {
    api.get('/ponto/portaria-funcionarios')
      .then((response) => {
        setFuncionarios(response.data.data || []);
      })
      .catch((err) => {
        console.error('Erro ao buscar funcionários:', err);
      });
  }, []);

  useEffect(() => {
    fetchFuncionarios();
  }, [fetchFuncionarios]);

  const handleDownloadPDF = () => {
    if (!dataInicio || !dataFim) return;
    setLoadingPdf(true);

    const params = { data_inicio: dataInicio, data_fim: dataFim };
    if (pessoaId) {
      params.pessoa_id = pessoaId;
    }
    if (user?.tipo_usuario === 'admin' && user?.empresa_id) {
      params.empresa_id = user.empresa_id;
    }

    api.get('/ponto/relatorio-pdf', { params, responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        window.open(url, '_blank');
      })
      .catch((error) => {
        console.error('Erro ao gerar PDF:', error);
      })
      .finally(() => {
        setLoadingPdf(false);
      });
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Relatório de Ponto
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <TextField
          label="Data Início"
          type="date"
          value={dataInicio}
          onChange={(e) => setDataInicio(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <TextField
          label="Data Fim"
          type="date"
          value={dataFim}
          onChange={(e) => setDataFim(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        {user?.tipo_usuario !== 'portaria' && (
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Todos os funcionários</InputLabel>
            <Select
              value={pessoaId}
              label="Todos os funcionários"
              onChange={(e) => setPessoaId(e.target.value)}
            >
              <MenuItem value="">Todos os funcionários</MenuItem>
              {funcionarios.map((f) => (
                <MenuItem key={f.id} value={f.id}>{f.nome}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Button
          variant="contained"
          startIcon={<PictureAsPdfIcon />}
          onClick={handleDownloadPDF}
          disabled={!dataInicio || !dataFim || loadingPdf}
          size="small"
        >
          {loadingPdf ? <CircularProgress size={24} color="inherit" /> : 'Gerar PDF'}
        </Button>
      </Box>
    </Paper>
  );
}

export default PontoRelatorio;
